import Vue from "vue";
import Router from "vue-router";

import Login from "@/views/Login.vue";
import Lotto from "@/views/Lotto.vue";
import Lottoery from "@/views/Lottoery.vue";

// ✅ 先加上（你等下再实现页面内容也可以先建空文件）
import Report from "@/views/Report.vue";
import ReportDetail from "@/views/ReportDetail.vue";
import Result from "@/views/Result.vue";
import ChangePassword from "@/views/ChangePassword.vue";
import Balance from "@/views/Balance.vue";
import Register from "@/views/Register.vue";

Vue.use(Router);

const router = new Router({
    mode: "hash",
    routes: [
        { path: "/login", component: Login },
        { path: "/register", component: Register },
        { path: "/lotto", component: Lotto, meta: { requiresAuth: true } },

        // 🚧 暂未开发也可以先保留
        { path: "/lottoery", component: Lottoery, meta: { requiresAuth: true } },

        // ✅ Report
        { path: "/report", component: Report, meta: { requiresAuth: true } },
        { path: "/report/:date", component: ReportDetail, meta: { requiresAuth: true } },
        { path: "/result", component: Result, meta: { requiresAuth: true } },
        { path: "/change-password", component: ChangePassword, meta: { requiresAuth: true } },
        { path: "/balance", component: Balance, meta: { requiresAuth: true } },
        { path: "/", redirect: "/lotto" }
    ]
});

function getToken() {
    return (
        sessionStorage.getItem("player_token") ||
        localStorage.getItem("player_token") ||
        ""
    );
}

router.beforeEach((to, from, next) => {
    const authed = !!getToken();
    if (to.matched.some((r) => r.meta.requiresAuth) && !authed) return next("/login");
    if (to.path === "/login" && authed) return next("/");
    next();
});

export default router;
